import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { forgotPassword } from "../../actions/authActions";
import { Grid, Button, InputAdornment, IconButton } from "@material-ui/core";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Visibility, VisibilityOff, Fingerprint } from "@material-ui/icons/";
import Alert from "@material-ui/lab/Alert";
import "./login.css";

const ForgotPassword = (props) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (error) {
      setError(null);
    }
  }, [password, confirmPassword]);

  useEffect(() => {
    if (props.msg === "Password Changes Successfully") {
      props.history.push(`/dashboard/${props.auth.seller._id}`);
    }
  }, [props.msg]);

  const changePassword = () => {
    props.forgotPassword(props.phoneNumber, password);
  };


  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "10%",
      }}
    >
      <div
        style={{ background: "aliceblue", borderRadius: 25, padding: "20px 0" }}
      >
        <h2
          style={{
            textAlign: "center",
          }}
        >
          Enter New Password
        </h2>
        <div style={{ margin: "70px" }}>
          <ValidatorForm onSubmit={() => changePassword()}>
            <div style={{ marginBottom: "20px " }}>
              <div style={{ display: "inline-flex", marginBottom: "10px" }}>
                <div style={{ margin: "8px 40px 0 0" }}>
                  <Fingerprint fontSize="large" />
                </div>
                <div>
                  <TextValidator
                    fullWidth={true}
                    label="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    variant="outlined"
                    onBlur={() => {
                      if (password.length < 8) {
                        setError("Password should've atleast 8 characters");
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <div style={{ display: "inline-flex", marginBottom: "10px" }}>
                <div style={{ margin: "8px 40px 0 0" }}>
                  <Fingerprint fontSize="large" />
                </div>
                <div>
                  <TextValidator
                    fullWidth={true}
                    label="Confirm Password"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    name="confirm_password"
                    type={showPassword ? "text" : "password"}
                    value={confirmPassword}
                    variant="outlined"
                    onBlur={() => {
                      if (password !== confirmPassword) {
                        setError("Confirm password should match password");
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
            {error && (
              <div className="responsive-alert">
                <Alert severity="error">{error}</Alert>
              </div>
            )}
            <Grid container justify="center" style={{ marginTop: "10px" }}>
              <Button color="primary" variant="contained" type="submit">
                Login
              </Button>
            </Grid>
          </ValidatorForm>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  msg: state.auth.msg,
});

export default connect(mapStateToProps, { forgotPassword })(ForgotPassword);
